import {CallbackHandler} from "@lxo-blocks/react";

export interface EnterNewPasswordProps {
  confirmationTicketId?: string;
  successHandler: PasswordSuccessHandler;
  currentError: string;
  submitMethod: CallbackHandler;
}

export interface EnterNewPasswordMFAProps {
  successHandler: PasswordSuccessHandler;
  currentError: string;
  submitMethod: CallbackHandler;
}

export interface NewPasswordTo {
  password1: string;
  password2: string;
}

export interface NewPasswordDataTo {
  confirmationId?: string;
  password1?: string;
  password2?: string;
  verificationCode?: string;
}

export interface ForgottenPasswordEmail {
  email: string;
}

export enum ForgottenPasswordStep {
  ENTER_EMAIL = "FORGOT_PASSWORT_EMAIL",
  SUCCESS = "FORGOT_PASSWORT_EMAIL_SUCCESS"
}

export enum EnterNewPasswordStep {
  ENTER_NEW_PASSWORD = "ENTER_NEW_PASSWORD",
  MFA = "MFA",
  RESET_MFA = "RESET_MFA"
}
export enum SetPasswordStep {
  SET_PASSWORD = "SET_PASSWORD",
}

export interface SuccessHandler {
  onSuccess: (forgottenPasswordEmail: ForgottenPasswordEmail) => void
}

export interface PasswordSuccessHandler {
  onSuccess: (response: any) => void
  onMfa: () => void
  onMfaReset: () => void
  onError: (error: any) => void
}

export interface ForgotPasswordFormProps {
  successHandler: SuccessHandler;
}

export interface PasswortResetAnswer {
  email: string;
}

export interface TotpToken {
  totptoken: string;
}
